import useAuthentication from "hooks/userAuthenticatication";
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import LocationService from '../../services/API/locationService';
import { getTimeZoneName, getTimeZoneOffsetFormatted } from "../../services/untils/formatDate";


const LoginVerify = () => {
    const [currentUserToken, setCurrentUserToken] = useState(null);
    const [searchParams] = useSearchParams();
    const [hiddenIndex, setHiddenIndex] = useState(null);
    const { dispatchSignInWithPhoneVerify, dispatchResendcode, dispatchSignInWithEmailLinkVerify } = useAuthentication();
    const [ip, setIp] = useState('');
    const navigate = useNavigate();
    const [locationData, setLocationData] = useState({
        ip: '',
        city: '',
        region: '',
        country: '',
        latitude: '',
        longitude: '',
    });

    useEffect(() => {
        fetchIp();
    }, []);

    const fetchIp = async () => {
        const res = await LocationService.getCurrentLocation();
        if (res && res?.query) {
            setLocationData({
                ip: res.query,
                city: res.city,
                region: res.regionName,
                country: res.country,
                lat: res.lat,
                lon: res.lon,
            });
        }
    };
    useEffect(() => {
        if (!isCallEmailVerify) {
            handleEmailOTCVerification();
        }
    }, [setLocationData])
    const handleQueryParams = (currentStep) => {
        return searchParams.get('callback') ? `step=${currentStep}&callback=${searchParams.get('callback')}` : `step=${currentStep}`;
    }
    let isCallEmailVerify = false;
    const handleEmailOTCVerification = async () => {
        if (isCallEmailVerify) {
            return;
        } else {
            isCallEmailVerify = true;
        }
        try {
            const timeZoneOffset = getTimeZoneOffsetFormatted();
            const timeZoneName = getTimeZoneName();
            let email = searchParams.get('email');
            let token = searchParams.get('token');
            let session = searchParams.get('session');
            const oTPRequest = {
                "emailAddress": `${email}`,
                // "otp": formData.otp.join(""),
                "session": session,
                "ipAddress": locationData.ip,
                "deviceId": "string",
                "timeZoneOffset": timeZoneOffset,
                "timeZoneName": timeZoneName,
                "token": token
            }
            const res = await dispatchSignInWithEmailLinkVerify(oTPRequest);
            if (res && res?.statusCode === 200) {
                if (res?.result?.email !== '' &&
                    res?.result?.first_name !== '' &&
                    res?.result?.last_name !== '' &&
                    res?.result?.fkGenderId !== '') {
                    localStorage.removeItem('phoneNumber');
                    localStorage.removeItem('emailAddress');
                    if (searchParams.get('callback')) {
                        window.location.href = searchParams.get('callback');
                        //navigate(searchParams.get('callback'));
                    } else {
                        window.location.href = "/landing";
                        //navigate("/landing");
                    }
                } else {
                    if (res?.result?.email && res?.result?.email !== '') {
                        // handleNextEvent(3); // Proceed to next step if needed
                        window.location.href = `/personalDetails?${handleQueryParams(3)}`;
                        //navigate(`/personalDetails?${handleQueryParams(3)}`);
                    } else {
                        // handleNextEvent(2); // Proceed to next step if needed
                        window.location.href = `/personalDetails?${handleQueryParams(2)}`;
                        //navigate(`/personalDetails?${handleQueryParams(2)}`);
                    }
                }
            } else {
                console.warn("Login unsuccessful", res.message || "Unauthorized access");
            }

        } catch (error) {
            console.error("Login failed: ", error);
        }
    }

    return (
        <h1 className="wait-title-txt">Please wait, we are verifying your email<span className="dots"></span></h1>
    );
}
export default LoginVerify;